import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, SetStateAction, useState } from "react";
import { useBillingBillRemoveCompanyRejection } from "../../hooks/useBillingBillRemoveCompanyRejection";

interface BillRemoveCompanyRejectionModalProps {
  billId?: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const BillRemoveCompanyRejectionModal = ({ billId, isOpen, setIsOpen }: BillRemoveCompanyRejectionModalProps) => {
  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: removeCompanyRejection,
    isPending: removeCompanyRejectionIsPending,
  } = useBillingBillRemoveCompanyRejection({
    billId,
    onSuccess: () => {
      setIsOpen(false);
      queryClient.invalidateQueries({ queryKey: ['billingBill', billId] });
    },
    onError: (response) => {
      setIsOpen(false);
      setMessages(response.response?.data.errors.base || ['Ocorreu um erro ao remover rejeição da empresa'])
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        subtitle="A rejeição da empresa será removida"
        subtitleClassName="mt-1 text-white-400"
        useCancellableFooter
        showClose={false}
        confirmButtonClassName="bg-primary-blue"
        confirmButtonIsLoading={removeCompanyRejectionIsPending}
        dataTestid="confirm_remove_failure"
        onConfirm={removeCompanyRejection}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  );
}

export default BillRemoveCompanyRejectionModal;
